import {Component, Input} from '@angular/core';
import {TranslationTabsModel} from './model/translation-tabs.model';

@Component({
  selector: 'app-translation-tabs',
  templateUrl: './translation-tabs.component.html',
  styleUrls: ['./translation-tabs.component.scss']
})
export class TranslationTabsComponent {
  @Input() translations: Array<TranslationTabsModel>;
  selectedLanguage: TranslationTabsModel = null;

  toggleLanguage(language: TranslationTabsModel) {
    this.selectedLanguage = this.selectedLanguage === language ? null : language;
  }
}
